module.exports = __webpack_public_path__ + "img/sala-do-empreendedor.756f078c.jpg";